import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  attachmentDetail,
  deleteAttachment,
  createAttachments,
  fetchAttachments,
  updateProject,
  postProject,
  resetErrorMessage,
  batchUpdateAttachments,
  deleteBoard,
  copyBoard,
  clearCopyBoardErrorState,
  clearCopyBoardSuccessState,
  fetchProjectDetails,
  loadAllFavoritedListings,
  loadAllBoards,
  joinBoard
} from '../actions/projects';
import {
  getInviteData
} from '../actions/action-store';
import Projects from '../../../../api/api-projects';
import ProjectInfo from '../../app-projects/project-info';
import ProjectListings from '../../app-projects/project-listings';
import ProjectMap from '../../app-projects/project-map';
import { ProjectPlaceholder } from '../../app-projects/project-placeholder';
import { NotificationBanner } from '../../elements-banner/notification-banner';
import ModalContainer from '../../app-projects/project-detail-modals';
import Transactable from 'shared-components/flow-transactable/transactable-main';
import { updateProfile200 } from '../../app-main/actions/auth';

import envAPI from '../../../../api/api-env';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const loadData = (SSOid, accessToken, loadBoards) => {
  if (SSOid && accessToken) {
    loadBoards(SSOid, accessToken);
  }
};

class ProjectDetailsContainer extends Component {
  constructor (props, context) {
    super(props, context);

    this.renderListingInfo = this.renderListingInfo.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeInviteModal = this.closeInviteModal.bind(this);
    this.inviteSave = this.inviteSave.bind(this);
    this.inviteSaveCb = this.inviteSaveCb.bind(this);
    this.goToBoardPage = this.goToBoardPage.bind(this);
    this.goToBoardsPage = this.goToBoardsPage.bind(this);
    this.boardHasBeenDeleted = this.boardHasBeenDeleted.bind(this);
    this.voteListing = this.voteListing.bind(this);
    this.changeButtonState = this.changeButtonState.bind(this);
    this.checkCredentials = this.checkCredentials.bind(this);
    this.checkForCollaborator = this.checkForCollaborator.bind(this);
    this.triggerTransactable = this.triggerTransactable.bind(this);
    this.getCollaborators = this.getCollaborators.bind(this);
    this.handleTransactable = this.handleTransactable.bind(this);
    this.handleCopyBoardButton = this.handleCopyBoardButton.bind(this);
    this.votingCommentingAnalytics = this.votingCommentingAnalytics.bind(this);
    this.handleTopSignupButton = this.handleTopSignupButton.bind(this);
    this.routeUserActionModal = this.routeUserActionModal.bind(this);
    this.closeSettingsModal = this.closeSettingsModal.bind(this);
    this.boardHasBeenSuccessfullyCopied = this.boardHasBeenSuccessfullyCopied.bind(this);
    this.clearErrorState = this.clearErrorState.bind(this);
    this.determineTransactableCb = this.determineTransactableCb.bind(this);
    this.descriptionAnalytics = this.descriptionAnalytics.bind(this);
    this.fetchFavedListings = this.fetchFavedListings.bind(this);
    this.signupAnalyticsAction = this.signupAnalyticsAction.bind(this);
    this.userDismissedLogin = this.userDismissedLogin.bind(this);
    this.userHasClickedJoin = this.userHasClickedJoin.bind(this);

    this.state = {
      activities: [],
      activityData: null,
      voteButtonDisabled: false,
      hasMounted: false,
      userLoggedInInvited: false,
      userLoggedOutInvited: false,
      userDismissedLogin: false,
      inviteId: null, 
      userClickedJoin: false,
      signInUserAction: null
    };
  }

  componentDidMount () {
    this.setState({
      hasMounted: true
    }, () => {
      const { project = {}, location = {} } = this.props;
      const inviteId = _.get(location, ['query', 'project_invite_id'], '');
      if(inviteId){
        PSSessions.Cookies.set('project_invite_id', inviteId);
      }
      const locale = SharedIntlProviderHOC.getLocale();
      if (project.activity) {
        envAPI.getActivities(locale, res => {
          const activities = res.response || [];
          const activityData = this.parsedActivities(activities, project.activity);

          this.setState({
            activityData,
            activities
          });
        });
      }
      if (inviteId) {
        this.setState({ inviteId: inviteId })
        this.props.getInviteData(inviteId);
      }
      this.routeUserActionModal();
    });
  }

  componentDidUpdate (prevProps) {
    const { profile,
      project = { },
      boardCopyExternalID,
      toggleModal,
      params,
      whichModal,
      params: {
        properties: userAction,
        externalID: externalId
      },
      fetchProjectDetails } = prevProps;
    const { props } = this;
    const { entities = {}, boardCopyExternalID: newlyCopiedBoardExternalID, boardCopyError: boardCopyHasError, params: { properties: newUserAction, externalID: newExternalId }, whichModal: newModal } = props;
    const updatedProject = props.project;
    const nextSSOid = _.get(props, ['profile', 'SSOid'], null);
    const nextAccessToken = _.get(props, ['accessToken'], null);
    const hasNewSSO = nextSSOid && (profile.SSOid !== nextSSOid);

    // if the prevProps invite data is different that the current inviteData
    // we will run our modal logic again with the new invite data
    if(_.get(prevProps, 'action_store.invite_data') !== _.get(props, 'action_store.invite_data') && !boardCopyHasError){
      this.routeUserActionModal()
    }

    if (hasNewSSO && _.get(props, 'params.properties') !== 'invite') {
      this.routeUserActionModal();
      this.fetchFavedListings(props);
      if (!entities.isFetching) {
        loadData(nextSSOid, nextAccessToken, props.loadAllBoards);
      }
    }

    if (externalId !== newExternalId) {
      fetchProjectDetails(newExternalId);
    }

    if (updatedProject && updatedProject.activity !== project.activity) {
      const { activities } = this.state;
      const activityData = this.parsedActivities(activities, updatedProject.activity);

      this.setState({
        activityData
      });
    }

    const hasNewAction = newUserAction !== userAction;
    const hasNewModal = newModal !== whichModal;
    const isntFetchingAnymore = !entities.isFetching;
    if ((hasNewAction || (hasNewSSO && !newModal)) && isntFetchingAnymore) {
      this.routeUserActionModal();
    }

    if (!boardCopyExternalID && newlyCopiedBoardExternalID) {
      this.boardHasBeenSuccessfullyCopied(newlyCopiedBoardExternalID);
      this.fetchFavedListings(props);
    }

    if (boardCopyHasError && !hasNewModal) {
      toggleModal('errorModal');
    }
  }

  boardHasBeenDeleted () {
    this.goToBoardsPage();
  }

  goToBoardsPage () {
    window.location.href = '/boards';
  }

  goToBoardPage (boardExternalID) {
    const path = `/boards/${boardExternalID}`;
    this.context.router.push({ pathname: path });
    this.routeUserActionModal();
  }

  routeUserActionModal () {
    const {
      params: {
        properties: userAction,
        externalID = ''
      },
      profile: {
        SSOid,
        isFetching,
        data: {
          email_verified
        }
      },
      project: {
        external_id: projectExternalId,
        created_by_sso_id: createdBySSO
      },
      toggleModal,
      joinBoard,
      whichModal,
      accessToken: isLoggedIn,
      action_store: {
        invite_data
      },
      entities: {
        projects
      } = {}
    } = this.props;

    const { userDismissedLogin, inviteId } = this.state;
    if (isLoggedIn && !isFetching) {
      const isBoardOwner = SSOid === createdBySSO;
      const isCollaborator = _.find(projects[projectExternalId].collaborators, { SSOid: SSOid });
      this.setState({ userLoggedInInvited: isBoardOwner || isCollaborator})
      const project = _.get(this.props, ['entities', 'projects', externalID]);
      const boardID = (project || {})._id;
      const userHadInviteId = !!PSSessions.Cookies('project_invite_id');
      if((!_.isEmpty(invite_data) || userHadInviteId) && !isBoardOwner && !isCollaborator && !whichModal){
        // we want to add them as a collab
        if (SSOid) {
          PSSessions.Cookies.set('project_invite_id', '');
          joinBoard(boardID, SSOid, isLoggedIn, externalID, inviteId)
            .then(() => {
              this.recordJoinAnalytics(project, SSOid);
              this.setState({ userLoggedInInvited: true})
            });
        }
      }

      if ('invite' === userAction) {
        toggleModal('');
        return this.setState({
          showInviteModal: true
        });
      }

      if (userAction && !isBoardOwner) {
        return this.goToBoardPage(projectExternalId);
      }

      if ('settings' === userAction) {
        return toggleModal('projectSettingsModal');
      }
    } else if (!_.isEmpty(invite_data) && !userDismissedLogin && !whichModal && 'invite' !== userAction) {
      // if the invite code is correct but the user is logged out throw the blocker modal
      this.setState({ userLoggedOutInvited: true });
      return toggleModal('joinBlockerModal');
    } else if ('invite' === userAction && !isLoggedIn) {
      return toggleModal('signUpLiteModal', () => {
        return toggleModal('avatarModal', () => {
          if (!email_verified) {
            return toggleModal('emailVerifyModal', () => {
              toggleModal('');
              return this.setState({
                showInviteModal: true
              });
            });
          }
          toggleModal('');
          return this.setState({
            showInviteModal: true
          });
        });
      });
    }
  }

  recordJoinAnalytics (project, ssoID) {
    const {
      name,
      description,
      cover_img_id: coverImage,
      _id: boardId,
      created_by_profile: {
        SSOid: createdByID,
        first_name: firstName,
        last_name: lastName,
        avatar_url: ownerAvatar
      }
    } = project;

    const analyticsProperties = {
      user_id: ssoID,
      board_id: boardId,
      board_title: name,
      board_description: description,
      cover_img_id: coverImage,
      owner_first_name: firstName,
      owner_ssoid: createdByID,
      owner_last_name: lastName,
      owner_avatar_url: ownerAvatar,
      invited: false
    }

    analyticsIntegrations.boardJoined(analyticsProperties);
  }

  closeSettingsModal () {
    this.goToBoardPage(this.props.params.externalID);
    this.props.toggleModal('');
  }

  changeButtonState () {
    this.setState({
      voteButtonDisabled: false
    });
  }

  handleCopyBoardButton () {
    const { project, accessToken } = this.props;
    const optionalObj = {
      source: 'copy board',
      flow_version: 'lite',
      app: 'web',
      label: 'copy board',
      method: 'email',
      page_type: 'boards'
    };

    const copyBoardTXCB = function copyBoardTXCB () {
      const projectID = _.get(this.props, 'project._id');
      const token = _.get(this.props, 'accessToken');
      this.props.copyBoard(projectID, token);
    }.bind(this);

    try {
      if (!accessToken) {
        this.checkCredentials(copyBoardTXCB, () => { }, 'copy board', null, null, optionalObj);
      } else {
        this.props.copyBoard(project._id, accessToken);
      }
    } catch {
        this.errorModalProps();
    }
  }

  handleTopSignupButton () {
    const userAction = () => {
      this.props.toggleModal('');
    };
    const optionalObj = {
      source: 'signup',
      flow_version: 'lite',
      app: 'web',
      label: 'signup',
      method: 'email',
      page_type: 'boards'
    };
    this.checkCredentials(userAction, this.signupAnalyticsAction.bind(this, optionalObj), 'signup', null, null, optionalObj);
  }

  signupAnalyticsAction (optionalObj) {
    const { project, profile } = this.props;
    analyticsIntegrations.votingCommenting('signup form viewed', 'signup', null, project, {}, optionalObj, profile);
  }

  checkCredentials (userAction, analyticsAction, action, index, listingID, optionalObj) {
    // userAction = voting, opening comment modal, and collab list, copy board, invite
    const { accessToken } = this.props;
    this.setState({ signInUserAction: action})
    if (!accessToken) {
      analyticsAction();
      return this.props.toggleModal('signUpLiteModal', newUser => {
        this.handleTransactable(newUser, userAction, action, index, listingID, optionalObj);
      });
    }
    return this.handleTransactable(false, userAction, action);
  }

  handleTransactable (newUser, userAction, action, index, listingID, optionalObj) {
    const SSOid = _.get(this.props, ['profile', 'SSOid'], '');
    const profileData = _.get(this.props, ['profile', 'data'], {});
    if (newUser) {
      this.votingCommentingAnalytics('account created', listingID, action, index, optionalObj, profileData);
    }
    return this.triggerTransactable(profileData, () => {
      // copy board is the only action that does not need collab check
      if ('copy board' !== action && 'signup' !== action) {
        if (this.checkForCollaborator()) {
          return this.determineTransactableCb(newUser, action, userAction);
        } if (SSOid) {
          analyticsIntegrations.genericBoardAction('access denied', _.get(this.props, 'project', {}), {});
          return this.props.toggleModal('permissionModal');
        }
      }
      return this.determineTransactableCb(newUser, action, userAction);
    });
  }

  determineTransactableCb (newUser, action, userAction) {
    if (newUser) {
      switch (action) {
      case 'UPVOTE':
      case 'DOWNVOTE':
        userAction();
        return this.props.toggleModal('avatarModal', () => {
          this.props.toggleModal('');
        });
      case 'vote tooltip':
      case 'copy board':
      case 'signup':
        return this.props.toggleModal('avatarModal', () => {
          userAction();
          this.props.toggleModal('');
        });
      default:
        return this.props.toggleModal('avatarModal', userAction);
      }
    }
    userAction();
    return this.props.toggleModal('');
  }

  getCollaborators () {
    const { project } = this.props;
    return _.get(project, ['collaborators'], []);
  }

  fetchFavedListings (nextProps) {
    const propsToUse = nextProps || this.props;
    const SSOid = _.get(propsToUse, ['profile', 'SSOid'], null);
    const accessToken = _.get(propsToUse, ['accessToken'], null);
    if (SSOid && accessToken) {
      this.props.loadAllFavoritedListings(SSOid, '', accessToken);
    }
  }

  checkForCollaborator () {
    const collaborators = this.getCollaborators();
    const SSOid = _.get(this.props, ['profile', 'SSOid'], '');
    const filterCollaborator = collaborators.filter((collab) => {
      return collab.SSOid === SSOid;
    });
    return 0 < filterCollaborator.length;
  }

  triggerTransactable (userProfile, userAction) {
    const actions = {};
    actions.updateProfile = () => { updateProfile200(userProfile); };
    // this.props.toggleModal('');
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <Transactable
          user={userProfile}
          domain="boards"
          intendedAction={userAction}
          actions={actions}
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  descriptionAnalytics (actionType, optionalObj) {
    const previousDescription = _.get(this.props, 'project.description', '');
    let action = actionType;
    if (!previousDescription && 'edit description' === actionType) {
      action = 'add description';
    } else if (previousDescription && 'description added' === actionType) {
      action = 'description edited';
    }
    analyticsIntegrations.genericBoardAction(action, _.get(this.props, 'project', {}), optionalObj);
  }

  votingCommentingAnalytics (actionType, listingID = '', userAction = '', index, optionalObj, profileData) {
    const { entities = {}, project } = this.props;
    const listingAttachment = _.get(entities, ['attachments', listingID], {});
    const listing = _.get(listingAttachment, ['listing'], {});
    const commentCount = parseInt(listingAttachment.comments, 10) || 0;
    const upvotes = parseInt(listingAttachment.upvotes, 10) || 0;
    const downvotes = parseInt(listingAttachment.downvotes, 10) || 0;
    const totalVotes = upvotes + downvotes;
    let boardListingObj = {};
    if (listingID) {
      boardListingObj = {
        board_sort_order: index + 1,
        total_comment_count: commentCount,
        total_vote_count: totalVotes,
        upvote_count: upvotes,
        downvote_count: downvotes
      };
    }
    analyticsIntegrations.votingCommenting(actionType, userAction, listing, project, boardListingObj, optionalObj, profileData);
  }

  voteListing (listingID, ns, voteId, listingIndex) {
    const { project: { _id }, accessToken, attachments = {} } = this.props;
    const listingAttachment = _.get(attachments, [listingID], {});
    const favAttachmentID = _.isEmpty(listingAttachment) ? '' : listingAttachment._id;
    const reqAtt = listingAttachment.requester_attachments || {};
    this.setState({
      voteButtonDisabled: true
    }, () => {
      if (voteId && (ns === reqAtt[voteId].ns)) {
        this.props.deleteAttachment(listingID, voteId, accessToken, ns)
          .then(this.changeButtonState)
          .then(this.votingCommentingAnalytics('board voted removed', listingID, ns, listingIndex))
          .catch(this.changeButtonState);
      } else {
        this.props.createAttachments(_id, favAttachmentID, accessToken, ns, this.state.inviteId, voteId)
          .then(this.changeButtonState)
          .then(this.votingCommentingAnalytics('board voted added', listingID, ns, listingIndex))
          .catch(this.changeButtonState);
      }
    });
  }

  closeModal () {
    $('#modal-container').modal('hide');
    return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
  }

  closeInviteModal () {
    this.closeModal();
    this.goToBoardPage(this.props.params.externalID);
    return this.setState({
      showInviteModal: false
    });
  }

  inviteSave (projectId, payload, callback) {
    const { accessToken } = this.props;
    Projects.createInvites(accessToken, projectId, payload, callback);
  }

  inviteSaveCb () {
    // Render success banner
    const bannerMessage = () => {
      return (
        <ul className="text-center list-inline">
          <li>
            <i className="ico icon-yes" />
          </li>
          <li><FormattedMessage id="boards.project_details_container.invite_sent" defaultMessage='Your invite was sent'/></li>
        </ul>
      );
    };
    this.closeModal();
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          timing={4.6}
          message={bannerMessage()}
        />
      </SharedIntlProviderHOC>, document.getElementById('banner-container'));
  }

  parsedActivities (activities, activity) {
    const activityHash = activities.reduce((hash, activity) => {
      hash[activity.dropdown] = {};
      hash[activity.dropdown].id = activity.id;
      hash[activity.dropdown].title = activity.dropdown;

      return hash;
    }, {});

    return activityHash[activity];
  }

  renderListingInfo () {
    const { listings, project = { } } = this.props;
    const { activityData, hasMounted, userLoggedInInvited, userLoggedOutInvited } = this.state;

    if (!hasMounted) {
      return;
    }
    if (!listings.length) {
      if (activityData && project.location) {
        return <ProjectPlaceholder activityData={ activityData } projectLocation={ project.location } />;
      }
    }
    return (
      <>
        <div className='col-xs-5 d-xs-none d-lg-block'>
          <ProjectMap listings={ listings } />
        </div>
        <div className="project-listings-container col-xs-12 col-lg-7">
          <ProjectListings
            closeModal={this.closeModal}
            activityData={ activityData }
            inviteSave={this.inviteSave}
            inviteSaveCb={this.inviteSaveCb}
            checkCredentials={this.checkCredentials}
            voteListing={this.voteListing}
            voteButtonDisabled={this.state.voteButtonDisabled}
            collaborators={this.getCollaborators()}
            votingCommentingAnalytics={this.votingCommentingAnalytics}
            descriptionAnalytics={this.descriptionAnalytics}
            fetchFavedListings={this.fetchFavedListings}
            signupAnalyticsAction={this.signupAnalyticsAction}
            userIsInvited={userLoggedInInvited || userLoggedOutInvited}
            inviteId={this.state.inviteId}
            {...this.props}
          />
        </div>
      </>
    );
  }

  boardHasBeenSuccessfullyCopied (boardCopyExternalID) {
    const { project, location } = this.props;
    const sourceBoardPath = location.pathname;
    const copiedBoardPath = `boards/${boardCopyExternalID}`;
    analyticsIntegrations.boardHasBeenCopied(project, sourceBoardPath, copiedBoardPath);
    const bannerMessage = (
      <div>
        <ul className="text-center list-inline">
          <li>
            <i className="ico ico-md icon-confirmed-check" />
          </li>
          <li className="text-large">
            <strong>
              <FormattedMessage id="boards.project_details_container.this_board" defaultMessage="This Board" />
            </strong>
            <span style={ { paddingLeft: '0' } }>&nbsp;
              <FormattedMessage
                id="boards.project_details_container.copied"
                defaultMessage="was copied to your account."
              />&nbsp;
            </span>
            <a className="btn-link text-white" href={ `/boards/${ boardCopyExternalID }` } style={ { textDecoration: 'underline' } }>
              <FormattedMessage
                id="boards.project_details_container.see_now"
                defaultMessage="See It Now"
              />
            </a>
          </li>
        </ul>
      </div>
    );
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          showClose
          timing={8}
          message={ bannerMessage }
        />
      </SharedIntlProviderHOC>, document.getElementById('banner-container'));
    this.props.clearCopyBoardSuccessState();
  }

  clearErrorState ({ externalID, callback }, redirect) {
    this.props.clearCopyBoardErrorState();
    return redirect ? callback(externalID) : null;
  }

  errorModalProps (props, goToBoardPage) {
    const { boardCopyError } = props;
    const errorModalProps = boardCopyError && boardCopyError.boardCopyExternalID ? {
      errorMessage: boardCopyError.errorMessage,
      CTAtext: this.props.intl.formatMessage({ id: 'boards.project_details_container.see_it_now', defaultMessage: 'See it now' }),
      clickArgs: { externalID: boardCopyError.boardCopyExternalID, callback: goToBoardPage },
      onClick: this.clearErrorState
    } : {};
    return errorModalProps;
  }

  userDismissedLogin() {
    this.setState({ userDismissedLogin: true })
  }

  userHasClickedJoin() {
    this.setState({ userClickedJoin: true })
  }

  render () {
    const { accessToken, project, profile } = this.props;
    if (!project) {
      return null;
    }
    return (
      <SharedIntlProviderHOC>
        <div>
          {this.state.hasMounted && (
            <>
              <ProjectInfo
                profile={profile}
                project={project}
                accessToken={accessToken}
                updateProject={this.props.updateProject}
                inviteSave={this.inviteSave}
                inviteSaveCb={this.inviteSaveCb}
                toggleModal={this.props.toggleModal}
                handleTopSignupButton={this.handleTopSignupButton}
                votingCommentingAnalytics={this.votingCommentingAnalytics}
                attachmentDetail={this.props.attachmentDetail}
                deleteBoard={this.props.deleteBoard}
                boardHasBeenDeleted={this.boardHasBeenDeleted}
                whichModal={this.props.whichModal}
                closeSettingsModal={this.closeSettingsModal}
                handleCopyBoardButton={this.handleCopyBoardButton}
                descriptionAnalytics={this.descriptionAnalytics}
                showInviteModal={this.state.showInviteModal}
                closeInviteModal={this.closeInviteModal}
                userLoggedInInvited={this.state.userLoggedInInvited}
                userLoggedOutInvited={this.state.userLoggedOutInvited}
                checkCredentials={this.checkCredentials}
                signupAnalyticsAction={this.signupAnalyticsAction}
              />
              <div className='container-project-details ps-container'>
                <div className='ps-row'>{this.renderListingInfo()}</div>
              </div>
              <ModalContainer
                {...this.props}
                errorModalProps={this.errorModalProps(
                  this.props,
                  this.goToBoardPage
                )}
                whichModal={this.props.whichModal}
                whichModalCb={this.props.whichModalCb}
                toggleModal={this.props.toggleModal}
                userDismissedLogin={this.userDismissedLogin}
                inviteId={this.state.inviteId}
                userHasClickedJoin={this.userHasClickedJoin}
                joinAnalytics={this.recordJoinAnalytics}
                signInUserAction={this.state.signInUserAction}
                userLoggedOutInvited={this.state.userLoggedOutInvited}
              />
            </>
          )}
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

ProjectDetailsContainer.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  profile: PropTypes.object,
  listings: PropTypes.array,
  accessToken: PropTypes.string,
  project: PropTypes.object.isRequired,
  entities: PropTypes.object.isRequired,
  attachments: PropTypes.object,
  updateProject: PropTypes.func,
  deleteBoard: PropTypes.func,
  getInviteData: PropTypes.func,
  toggleModal: PropTypes.func,
  copyBoard: PropTypes.func,
  deleteAttachment: PropTypes.func,
  createAttachments: PropTypes.func,
  clearCopyBoardSuccessState: PropTypes.func,
  clearCopyBoardErrorState: PropTypes.func,
  fetchProjectDetails: PropTypes.func,
  attachmentDetail: PropTypes.func,
  whichModalCb: PropTypes.func,
  boardCopyExternalID: PropTypes.string,
  whichModal: PropTypes.string,
  boardCopyError: PropTypes.object
};

ProjectDetailsContainer.contextTypes = {
  router: PropTypes.object
};

function mapStateToProps (state, ownProps) {
  const projectID = ownProps.params.externalID;
  const {
    auth: { accessToken },
    profile,
    entities,
    action_store
  } = state;

  const { projects, attachments, boardCopyExternalID, boardCopyError } = entities;
  const project = projects[projectID];

  // In the event that no listing attachments exists,
  // we return an empty listings Array.
  const listings = attachments
    ? Object.keys(attachments).reduce((acc, key) => {
      if (attachments[key].listing) {
        acc.push(attachments[key].listing);
      }
      return acc;
    }, [])
    : [];

  return {
    profile,
    accessToken,
    attachments,
    listings,
    projects,
    entities,
    project,
    action_store,
    boardCopyExternalID,
    boardCopyError
  };
}

export default injectIntl(connect(mapStateToProps, {
  updateProject,
  postProject,
  resetErrorMessage,
  batchUpdateAttachments,
  fetchAttachments,
  createAttachments,
  deleteAttachment,
  attachmentDetail,
  updateProfile200,
  getInviteData,
  deleteBoard,
  copyBoard,
  clearCopyBoardErrorState,
  clearCopyBoardSuccessState,
  fetchProjectDetails,
  loadAllFavoritedListings,
  loadAllBoards,
  joinBoard
})(ProjectDetailsContainer));
